/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { bool, string, object } from 'prop-types';
import Error from '@material-ui/icons/Error';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import ReactHtmlParser from 'react-html-parser';
import { formatString } from './Helper/Helper';

const styles = (theme) => ({
    errorMsg: {
        color: theme.palette.error.main,
        backgroundColor: '#FFF',
        padding: '3px',
        wordWrap: 'break-word',
    },
    addShadow: {
        boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)',
    },
    icon: {
        fontSize: '1.4rem',
        marginTop: '-5px',
        marginRight: '4px',
        marginBottom: '-5px',
        display: 'inline',
    },
    iconPromotion: {
        margin: '0 4px 0 0',
        float: 'left',
        fontSize: '14px',
    },
    message: {
        display: 'inline',
    },
});

const ErrorMessage = ({
    noShadow, error, presentation_family, widgetType, align, classes,
}) => {
    let classIcon = classes.icon;
    let classesErrorMessage = '';
    if (presentation_family === 'food' && widgetType === 'promotion') {
        classIcon = classes.iconPromotion;
    }
    classesErrorMessage = (!noShadow) ? classes.addShadow : '';
    return (
        <Typography
            align={align}
            variant="body2"
            className={`${classes.errorMsg} ${classesErrorMessage}`}
        >
            <Error className={classIcon} color="error" />
            <span className={classes.message}> { ReactHtmlParser(formatString(error)) } </span>
        </Typography>
    );
};

ErrorMessage.propTypes = {
    error: string.isRequired,
    noShadow: bool,
    presentation_family: string,
    widgetType: string,
    align: string,
    classes: object.isRequired,
};

ErrorMessage.defaultProps = {
    noShadow: false,
    presentation_family: '',
    widgetType: '',
    align: 'left',
};

export default withStyles(styles)(ErrorMessage);
